module.exports = __webpack_public_path__ + "img\\pad_img1.3042e774.png";